import 'css-chunksrc/client/scenes/wbs/tags/styles.scss';export default {
  "tags": "_tags_lwun6_1",
  "tag": "_tag_lwun6_1",
  "text": "_text_lwun6_20",
  "icon": "_icon_lwun6_28",
  "form": "_form_lwun6_34"
};